/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateTopicRequest
 */
export interface CreateTopicRequest {
    /**
     * The name of the topic. Must contain only letters, numbers, and dashes.
     * @type {string}
     * @memberof CreateTopicRequest
     */
    name: string;
}

/**
 * Check if a given object implements the CreateTopicRequest interface.
 */
export function instanceOfCreateTopicRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function CreateTopicRequestFromJSON(json: any): CreateTopicRequest {
    return CreateTopicRequestFromJSONTyped(json, false);
}

export function CreateTopicRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTopicRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function CreateTopicRequestToJSON(value?: CreateTopicRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

